import React from 'react';
import styles from './CoreTable.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { RichText } from '@/components';

let cx = className.bind(styles);

export default function CoreTable(props) {
	const { attributes } = props;
  const className = attributes.className?.split(' ') || [];

	function TableRow({ data, cellType }) {
		return data.map((row, index) => (
			<tr key={index}>
				<TableCell row={row} cellType={cellType} />
			</tr>
		));
	}

	function TableCell({ row, cellType }) {
		return row.cells.map((cell, index) => <RichText elem={cellType} key={index} html={cell.content} className={cell.align && `textAlign-${cell.align}`} /> );
	}

	return (
		<table id={attributes.anchor} className={cx(['ns_table', 'table', ...className, attributes.hasFixedLayout && 'fixed-layout', attributes.align && `align-${attributes.align}`, attributes.backgroundColor && `bg-${attributes.backgroundColor}`, attributes.textColor && `text-color-${attributes.textColor}`, attributes.fontSize === 'sm' && 'is-font-size-sm'])}>
      {attributes.caption && <caption>{attributes.caption}</caption>}
			{attributes.head && (
				<thead>
					<TableRow data={attributes.head} cellType="th" />
				</thead>
			)}
			{attributes.body && (
				<tbody>
					<TableRow data={attributes.body} cellType="td" />
				</tbody>
			)}
			{attributes.foot && (
				<tfoot>
					<TableRow data={attributes.foot} cellType="td" />
				</tfoot>
			)}
		</table>
	);
}

CoreTable.fragments = {
	key: `CoreTableFragment`,
	entry: gql`
		fragment CoreTableFragment on CoreTable {
			attributes {
				align
				anchor
        backgroundColor
        textColor
				className
				hasFixedLayout
        fontSize
				foot {
					cells {
						content
            align
					}
				}
				head {
					cells {
						content
            align
					}
				}
				caption
				body {
					cells {
						content
            align
					}
				}
			}
		}
	`,
};


CoreTable.config = {
	name: 'CoreTable',
};
CoreTable.displayName = 'CoreTable';